// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add all variables here */
:host {
  display: flex;
  justify-content: center;
}

.product {
  display: grid;
  grid-template-columns: 120px auto;
  background-color: white;
  padding: 24px;
  border-radius: 4px;
  border: 1px solid #560F32;
  margin: 12px;
  container: product-card/inline-size;
  font-family: "barlow condensed", sans-serif;
  max-width: 600px;
  width: calc(100vw - 36px);
}

.product-image {
  flex: 0 0 120px;
  height: 300px;
  padding-right: 24px;
  grid-area: 1/1/3/1;
}
.product-image img {
  object-position: center;
}

.product-title {
  font-family: "Bebas Neue", sans-serif;
  font-size: 2rem;
  line-height: 2rem;
}

.alcohol {
  font-size: 1.4rem;
  white-space: nowrap;
}

.rating-points {
  font-size: 1.4rem;
  font-weight: bold;
  color: #F7941E;
  padding-right: 12px;
  width: fit-content;
}

.rating-dot {
  font-size: 1.3rem;
  vertical-align: text-bottom;
}

.rating-label {
  font-size: 1.4rem;
  padding-left: 12px;
  font-weight: 400;
}

.product-foods {
  display: grid;
  grid-template-columns: 20% 20% 20% 20% 20%;
  align-items: center;
}

.product-foods-title {
  margin-top: 16px;
  font-size: 1.6rem;
  font-weight: 400;
}

.product-food {
  text-align: center;
  font-size: 1.1rem;
}

@container product-card (width < 460px) {
  .product-image {
    grid-area: 1/1/1/1;
  }
  .rating-points {
    display: block;
    padding-right: 0;
  }
  .rating-dot {
    display: none;
  }
  .rating-label {
    display: block;
    padding-left: 0;
    margin-bottom: 8px;
  }
  .product-foods-container {
    grid-column: 1/3;
  }
}`, "",{"version":3,"sources":["webpack://./src/variables.scss","webpack://./src/app/content/modules/storyblok/components/storyblok-product-card/storyblok-product-card.component.scss"],"names":[],"mappings":"AAAA,2BAAA;ACGA;EACE,aAAA;EACA,uBAAA;AADF;;AAIA;EACE,aAAA;EACA,iCAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,mCAAA;EACA,2CAAA;EACA,gBAAA;EACA,yBAAA;AADF;;AAIA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AADF;AAGE;EACE,uBAAA;AADJ;;AAKA;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,mBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,iBAAA;EACA,cD1CY;EC2CZ,mBAAA;EACA,kBAAA;AAFF;;AAKA;EACE,iBAAA;EACA,2BAAA;AAFF;;AAKA;EACE,iBAAA;EACA,kBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,aAAA;EACA,0CAAA;EACA,mBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,iBAAA;AAFF;;AAKA;EAEE;IACE,kBAAA;EAHF;EAMA;IACE,cAAA;IACA,gBAAA;EAJF;EAOA;IACE,aAAA;EALF;EAQA;IACE,cAAA;IACA,eAAA;IACA,kBAAA;EANF;EASA;IACE,gBAAA;EAPF;AACF","sourcesContent":["/* Add all variables here */\n\n@import \"bootstrap/scss/functions\";\n@import \"bootstrap/scss/variables\";\n\n$text-orange: #F7941E;\n$wine-red-light: #5c0a31;\n$wine-red-dark: #3d051f;\n$wine-text-color: #37041c;\n$light-grey: #efefef;\n$yellow-cta: #ff9812;\n$gold: #e0b55d;\n$color-cloud-grey: #F9F9F9;\n$color-grey: #d5d5d5;\n$color-almost-black: #212529;\n$stock-green: #60E040;\n\n$supervin-color-bordeaux: #3E0523;\n\n$color-charcoal-black: #000;\n$theme-colors: (\n  \"primary\": $yellow-cta,\n  \"secondary\": $secondary,\n  \"success\": $yellow-cta, //$success,\n  \"info\": $yellow-cta, //$info,\n  \"warning\": $warning,\n  \"danger\": $danger,\n  \"light\": $light,\n  \"dark\": $dark\n);\n\n$container-max-widths: (\n  xl: 1280px\n);\n\n$header-height: 100px;\n\n$border-divider: 1px solid $color-cloud-grey;\n$breadcrumb-height: 30px;\n\n@mixin supervin-box-shadow {\n  box-shadow: 1px 1px 5px 0 rgba(0,0,0,0.4);\n}\n\n@mixin btn-primary {\n\n  border-radius: 0;\n  text-transform: uppercase;\n  padding: 0.7rem 1.3rem;\n  font-size: 0.8rem;\n  background-color: $yellow-cta;\n  border: solid 1px $yellow-cta;\n  display: inline-block;\n  font-weight: 400;\n  text-align: center;\n  vertical-align: middle;\n  user-select: none;\n  line-height: 1.5;\n  text-decoration: none;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n\n\n","@import \"src/variables\";\n@import \"bootstrap/scss/mixins/breakpoints\";\n\n:host {\n  display: flex;\n  justify-content: center;\n}\n\n.product {\n  display: grid;\n  grid-template-columns: 120px auto;\n  background-color: white;\n  padding: 24px;\n  border-radius: 4px;\n  border: 1px solid #560F32;\n  margin: 12px;\n  container: product-card / inline-size;\n  font-family: \"barlow condensed\", sans-serif;\n  max-width: 600px;\n  width: calc(100vw - 36px);\n}\n\n.product-image {\n  flex: 0 0 120px;\n  height: 300px;\n  padding-right: 24px;\n  grid-area: 1 / 1 / 3 / 1;\n\n  img {\n    object-position: center;\n  }\n}\n\n.product-title {\n  font-family: \"Bebas Neue\", sans-serif;\n  font-size: 2rem;\n  line-height: 2rem;\n}\n\n.alcohol {\n  font-size: 1.4rem;\n  white-space: nowrap;\n}\n\n.rating-points {\n  font-size: 1.4rem;\n  font-weight: bold;\n  color: $text-orange;\n  padding-right: 12px;\n  width: fit-content;\n}\n\n.rating-dot {\n  font-size: 1.3rem;\n  vertical-align: text-bottom;\n}\n\n.rating-label {\n  font-size: 1.4rem;\n  padding-left: 12px;\n  font-weight: 400;\n}\n\n.product-foods {\n  display: grid;\n  grid-template-columns: 20% 20% 20% 20% 20%;\n  align-items: center;\n}\n\n.product-foods-title {\n  margin-top: 16px;\n  font-size: 1.6rem;\n  font-weight: 400;\n}\n\n.product-food {\n  text-align: center;\n  font-size: 1.1rem;\n}\n\n@container product-card (width < 460px) {\n\n  .product-image {\n    grid-area: 1 / 1 / 1 / 1;\n  }\n\n  .rating-points {\n    display: block;\n    padding-right: 0;\n  }\n\n  .rating-dot {\n    display: none;\n  }\n\n  .rating-label {\n    display: block;\n    padding-left: 0;\n    margin-bottom: 8px;\n  }\n\n  .product-foods-container {\n    grid-column: 1 / 3;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
